import React from 'react';
import { FmlxButton } from 'fmlx-common-ui';
import imgBestfit from 'components/main/images/BestFit.png';
import imgZoomOut from 'components/main/images/ZoomOut.png';
import imgZoomIn from 'components/main/images/ZoomIn.png';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { useRMDispatch } from 'redux/hooks';
import { toggleZoomLock } from 'redux/reducers/commonReducer';
import { useIsZoomLocked } from 'redux/hooks/common';
import { isDropModeUrl } from 'utils/Global';
import { Footer } from '../result/footer';

interface Props {
  zoomInvocker: (zoomIn: number) => void;
}
const BottomMenu = (props: Props) => {
  const { zoomInvocker } = props;
  const isZoomLocked = useIsZoomLocked();
  const dispatch = useRMDispatch();
  const isDropMode = isDropModeUrl();

  function fullScreen() {
    if (zoomInvocker) {
      zoomInvocker(0);
    }
  }

  function zoomOut() {
    if (zoomInvocker) {
      zoomInvocker(-1);
    }
  }

  function zoomIn() {
    if (zoomInvocker) {
      zoomInvocker(+1);
    }
  }

  return (
    <div
      id="searchandfilter-bottom-menu-wrapper"
      className={`flex justify-start w-full h-[7%] bg-[#C4C4C4] z-[1] absolute bottom-0`}
    >
      <div
        id="searchandfilter-bottom-menu-container"
        className="flex-y-center overflowBottomMenu"
      >
        <div
          id="searchandfilter-bottom-menu-best-fit"
          data-tip="Best Fit"
          className="margin5"
        >
          <FmlxButton
            onClick={fullScreen}
            className="navButton buttonFmlx"
            style={{ backgroundImage: `url(${imgBestfit})` }}
            disabled={isDropMode && isZoomLocked}
            onlyIcon
            tooltipDescription="Best Fit"
          />
        </div>
        {}
        <div
          id="searchandfilter-bottom-menu-zoom-out"
          data-tip="Zoom Out"
          className="margin5"
        >
          <FmlxButton
            onClick={zoomOut}
            className="navButton buttonFmlx"
            style={{ backgroundImage: `url(${imgZoomOut})` }}
            disabled={isDropMode && isZoomLocked}
            onlyIcon
            tooltipDescription="Zoom Out"
          />
        </div>
        {}
        <div
          id="searchandfilter-bottom-menu-zoom-in"
          data-tip="Zoom In"
          className="margin5"
        >
          <FmlxButton
            onClick={zoomIn}
            className="navButton buttonFmlx"
            style={{ backgroundImage: `url(${imgZoomIn})` }}
            disabled={isDropMode && isZoomLocked}
            onlyIcon
            tooltipDescription="Zoom In"
          />
        </div>

        {isDropMode && (
          <div
            id="searchandfilter-bottom-menu-toggle-lock"
            data-tip={isZoomLocked ? 'Unlock Zoom' : 'Lock Zoom'}
            className="margin5"
          >
            <RMCustomButton
              iconProps={{ name: isZoomLocked ? 'Unlock' : 'Lock', fill: 'white' }}
              mainContainerClass="w-[36px] h-[42px] bg-[#666666] rounded-md"
              onClick={() => dispatch(toggleZoomLock())}
            />
          </div>
        )}
      </div>
      <Footer className="w-[62%] h-full bg-[#C4C4C4] flex flex-row-reverse align-center px-3" />
    </div>
  );
};

export default BottomMenu;
